export default __webpack_public_path__ + "bookmark_border.052fb591.svg";